import styled from 'styled-components';
import { StyledProps } from 'types/styles';
import { typography, color, space, flexbox, layout, borderRadius, border, display } from 'styled-system';
import { Link } from 'lib/router';

interface Props extends StyledProps {
  noUnderline?: boolean;
}

export const BaseText = styled.div<Props>`
  ${typography}
  ${color}
  ${space}
  ${borderRadius}
  ${border}
  ${display}
  ${layout}
  ${flexbox}
`;

BaseText.defaultProps = {
  fontSize: 1,
  color: 'blacks.1',
};

export const SmallText = styled.div<Props>`
  ${typography}
  ${color}
  ${space}
`;

SmallText.defaultProps = {
  fontSize: 0,
  color: 'blacks.1',
  lineHeight: '16px',
};

export const LargeText = styled.div<Props>`
  ${typography}
  ${color}
  ${space}
`;

LargeText.defaultProps = {
  fontSize: 4,
  color: 'blacks.1',
};

export const PageHeader = styled.h1<Props>`
  ${typography}
  ${color}
  ${space}
  ${border}
  ${layout}
  ${flexbox}
`;

PageHeader.defaultProps = {
  fontSize: 7,
  fontWeight: 2,
  minHeight: '36px',
  lineHeight: '36px',
  fontFamily: 'Feature',
};

export const H1 = styled.h1<Props>`
  ${color}
  ${typography}
  ${space}
  ${border}
  ${flexbox}
`;

H1.defaultProps = {
  color: 'blacks.1',
  fontWeight: 2,
  fontSize: '28px',
  fontFamily: 'Feature',
};

export const H2 = styled.h2<Props>`
  ${color}
  ${typography}
  ${space}
  ${border}
  ${flexbox}
  ${layout}
`;

H2.defaultProps = {
  color: 'blacks.1',
  fontWeight: 1,
  fontSize: '26px',
  fontFamily: 'Feature',
  lineHeight: 2,
};

export const H3 = styled.h3<Props>`
  ${color}
  ${space}
  ${typography}
  ${layout}
  ${flexbox}
`;

H3.defaultProps = {
  color: 'blacks.1',
  fontWeight: 1,
  fontSize: '16px',
  lineHeight: '16px',
  letterSpacing: '-1%',
};

export const H4 = styled.h4<Props>`
  ${color}
  ${space}
  ${typography}
  ${layout}
  ${flexbox}
`;

H4.defaultProps = {
  color: 'blacks.1',
  fontWeight: 2,
};

export const StyledLink = styled(Link)<Props>`
  ${color}
  ${typography}
  ${space}
  text-decoration: ${({ noUnderline }) => (noUnderline ? 'none' : 'underline')};

  &:hover {
    ${color}
  }
`;

StyledLink.defaultProps = {
  color: 'blue700',
  fontSize: 1,
  fontWeight: 1,
};

export const SpanText = styled.span<Props>`
  ${color}
  ${space}
  ${typography}
  ${layout}
  ${flexbox}
`;

export const PointerText = styled.div<Props>`
  ${typography}
  ${color}
  ${space}
`;

export const SmallHeader = styled.div<Props>`
  ${color}
  ${space}
  ${typography}
  ${layout}
  ${flexbox}
  ${border}

  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

SmallHeader.defaultProps = {
  color: 'blacks.1',
  fontSize: 0,
  fontWeight: 2,
};

export const StyledExternalLink = styled.a<Props>`
  ${typography}
  ${color}
  ${space}
  ${borderRadius}
  ${border}
  ${display}
  ${layout}
  ${flexbox}

  &:hover {
    ${color}
  }
`;

StyledExternalLink.defaultProps = {
  fontSize: 1,
  color: 'blues.2',
};
